import { Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { ProfileEditorWrapper } from '../common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AboutYouBox = function AboutYouBox(_ref) {
  var questionRef = _ref.questionRef,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(ProfileEditorWrapper, {
    ref: questionRef,
    "data-element": "ProfileEditorWrapper",
    "data-component": "AboutYouBox",
    "data-source-file": "about-you-box.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      sx: {
        mb: 3
      },
      variant: "h2",
      "data-element": "Typography",
      "data-component": "AboutYouBox",
      "data-source-file": "about-you-box.tsx",
      children: /*#__PURE__*/_jsx(Translation, {
        "data-element": "Translation",
        "data-component": "AboutYouBox",
        "data-source-file": "about-you-box.tsx",
        children: function children(t) {
          return t('About you');
        }
      })
    }), children]
  });
};